import { Component, OnInit, OnDestroy } from '@angular/core';

import { ConfirmationService } from '../../services/confirmation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
  isVisible = false;
  title = '';
  message = '';
  confirmText = 'Confirmer';
  cancelText = 'Annuler';

  private resolveFunction: ((result: boolean) => void) | null = null;
  private subscription?: Subscription;

  constructor(private confirmationService: ConfirmationService) {}

  ngOnInit(): void {
    this.subscription = this.confirmationService.confirmation$.subscribe(data => {
      this.title = data.title;
      this.message = data.message;
      this.confirmText = data.confirmText || 'Confirmer';
      this.cancelText = data.cancelText || 'Annuler';
      this.resolveFunction = data.resolve;
      this.isVisible = true;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  confirm(): void {
    this.isVisible = false;
    if (this.resolveFunction) {
      this.resolveFunction(true);
      this.resolveFunction = null;
    }
  }

  cancel(): void {
    this.isVisible = false;
    if (this.resolveFunction) {
      this.resolveFunction(false);
      this.resolveFunction = null;
    }
  }

  onBackdropClick(): void {
    this.cancel();
  }
}
